/* eslint-disable @typescript-eslint/camelcase */
export interface AuditLogsResults {
  user: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
  };
  persistent_user_first_name: string;
  persistent_user_last_name: string;
  persistent_user_email: string;
  action: AuditLogsActions;
  resource: AuditLogsResources;
  resource_uuid: string;
  resource_identifier: string;
  context_json: Record<string, string>;
  details_json: Record<string, [any, any]>;
  created_at: string;
}
export type AuditLogsResponse = PaginatedResponse<AuditLogsResults>;

export enum AuditLogsActions {
  ACTION_CREATE = 'create_resource',
  ACTION_UPDATE = 'update_resource',
  ACTION_DELETE = 'delete_resource',
  ACTION_PUBLISH = 'publish_resource',
  ACTION_MIGRATE_RESOURCE = 'migrate_resource',
}
export enum AuditLogsResources {
  RESOURCE_OPERATOR = 'operator',
  RESOURCE_COMPANY = 'company',
  RESOURCE_PARTNER = 'partner',
  RESOURCE_ENVIRONMENT = 'environment',
  RESOURCE_CLIENT = 'client',
  RESOURCE_USER = 'user',
  RESOURCE_CLIENT_APPLICATION = 'client_application',
  RESOURCE_USER_SESSION = 'user_session',
  RESOURCE_PARTNER_USER_THEME_CONFIG = 'partner_user_theme_config',
  RESOURCE_OPERATOR_ROLE = 'operator_role',
  RESOURCE_OPERATOR_ROLE_OBJECTS = 'operator_role_objects',
  RESOURCE_OPERATOR_ROLE_PERMISSION = 'operator_role_permission',
}

export interface AuditLogsState {
  readonly auditLogsData: AuditLogsResponse;
  readonly isLoading: boolean;
}
